<script lang="ts" setup>
const props = defineProps<{
  isConnected: boolean;
  offlineAt: Date;
}>();

const { coords } = useGPS();
const latitude = computed(() => Number(coords.value?.latitude?.toFixed(6)) || 0);
const longitude = computed(() => Number(coords.value?.longitude?.toFixed(6)) || 0);
</script>

<template>
  <div class="mt-5">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-2 pb-2 px-5 border-b-2 border-gray-300">
      <div class="flex items-center">
        <div class="h-3 w-3 rounded-full me-2 animate-pulse" :class="isConnected ? 'bg-green-400' : 'bg-red-500'"></div>
        <div class="text-sm">{{ isConnected ? ' Verbunden' : 'Nicht verbunden' }}</div>
      </div>

      <div
        class="text-left md:text-right text-sm w-full flex md:justify-end gap-2 md:gap-3 items-center justify-between"
      >
        <span v-if="isConnected" class="flex items-center text-sm font-light"
          ><Icon class="mr-2 text-base" name="bi:arrow-repeat" />Live</span
        >
        <span v-else class="text-sm font-light"
          ><Icon class="mr-2 text-base" name="bi:arrow-repeat" />{{
            $dayjs(offlineAt).format('DD.MM.YYYY - HH:mm:ss')
          }}</span
        >
        <span class="text-sm font-light"
          ><Icon class="mr-2 text-base" name="bi:geo" />{{ latitude }}, {{ longitude }}</span
        >
      </div>
    </div>
  </div>
</template>
